import React, { useEffect } from 'react';
import './style.css';
import './bootstrap.min.css';

function Amenities() {
    
    useEffect(() => {
        // பக்கத்தின் தலைப்பு மற்றும் மெட்டா விவரங்களை மாற்றுதல்
        document.title = "Our Services | Unicell Technologies Limited";
        const metaDesc = document.querySelector('meta[name="description"]');
        if (metaDesc) {
            metaDesc.setAttribute('content', "Explore our industrial solutions: Paper Mills, Tissue Paper Converting, Plastic Recycling, Biomass Energy, and International Trading.");
        }

        // Clientele Carousel - jQuery மூலம் இயக்குதல்
        if (window.$ && window.$(".vendor-carousel").length > 0) {
            window.$(".vendor-carousel").owlCarousel({
                loop: true,
                margin: 45,
                autoplay: true,
                smartSpeed: 1000,
                responsive: {
                    0: { items: 2 },
                    576: { items: 4 },
                    768: { items: 6 },
                    992: { items: 8 }
                }
            });
        }
    }, []);

    // சர்வீஸ் டேட்டா (சுலபமாக பராமரிக்க)
    const services = [
        { title: "Paper Mills", desc: "Specializing in setting up complete tissue and Kraft packaging paper mills.", img: "img/paper.png" },
        { title: "Tissue Paper", desc: "Hygienic tissue paper converting plants and solutions.", img: "img/tissue-box.png" },
        { title: "Plastic", desc: "Plastic recycling and upcycling business to produce added value products.", img: "img/plastic.png" },
        { title: "Biomass Energy", desc: "Using natural and waste biomass to generate clean power.", img: "img/biomass.png" },
        { title: "International Trading", desc: "Raw material and general trading of industrial commodities.", img: "img/free-trade.png" },
        { title: "Municipal Waste", desc: "Sustainable handling and processing of community waste.", img: "img/garbage.png" }
    ];

    return (
        <>

           <div className="container-fluid bg-primary py-5 bg-header">
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">Services</h1>
                    <a href="" className="h5 text-white">Home</a>
                    <i className="far fa-circle text-white px-2"></i>
                    <a href="" className="h5 text-white">Services</a>
                </div>
            </div>
        </div>
            {/* தேடல் வசதி (Search Modal) */}
            <div className="modal fade" id="searchModal" tabIndex="-1">
                <div className="modal-dialog modal-fullscreen">
                    <div className="modal-content" style={{ background: "rgba(9, 30, 62, .7)" }}>
                        <div className="modal-header border-0">
                            <button type="button" className="btn bg-white btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                        </div>
                        <div className="modal-body d-flex align-items-center justify-content-center">
                            <div className="input-group" style={{ maxWidth: "600px" }}>
                                <input type="text" className="form-control bg-transparent border-primary p-3" placeholder="Type search keyword" />
                                <button className="btn btn-primary px-4"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* சர்வீஸ் பகுதி (Service Start) */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container py-5">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Our Services</h5>
                        <h1 className="mb-0">Best Solutions for Your Business</h1>
                    </div>
                    
                    <div className="row g-5">
                        {services.map((item, index) => (
                            <div key={index} className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay={`${0.3 * (index % 3 + 1)}s`}>
                                <div className="service-item bg-light rounded d-flex flex-column align-items-center justify-content-center text-center p-4">
                                    <div className="service-icon mb-4">
                                        <img src={item.img} style={{ width: "50px" }} alt={item.title} />
                                    </div>
                                    <h4 className="mb-3">{item.title}</h4>
                                    <p className="m-0">{item.desc}</p>
                                    <button className="btn btn-lg btn-primary rounded mt-4">
                                        <i className="bi bi-arrow-right"></i>
                                    </button>
                                </div>
                            </div>
                        ))}

                        {/* ஈமெயில் குரி (Email Query Box) */}
                        <div className="col-lg-4 col-md-6 wow zoomIn" data-wow-delay="0.9s">
                            <div className="position-relative bg-primary rounded h-100 d-flex flex-column align-items-center justify-content-center text-center p-5 shadow">
                                <h3 className="text-white mb-3">Email us with your Query</h3>
                                <p className="text-white mb-4">Send us an email and we will respond promptly.</p>
                                <h6 className="text-white mb-1">gsharma@unicellusa.com</h6>
                                <h6 className="text-white mb-0">info@unicellusa.com</h6>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            {/* கிளையண்ட் லோகோக்கள் (Clientele Start) */}
            <div className="container-fluid py-5 wow fadeInUp" data-wow-delay="0.1s">
                <div className="container">
                    <div className="section-title text-center position-relative pb-3 mb-5 mx-auto" style={{ maxWidth: "600px" }}>
                        <h5 className="fw-bold text-primary text-uppercase">Clientele</h5>
                    </div>
                    <div className="bg-white p-4 border border-primary rounded shadow-sm">
                        <div className="owl-carousel vendor-carousel">
                            <img src="img/wecycle.jfif" alt="Client" />
                            <img src="img/inside.jfif" alt="Client" />
                            <img src="img/glg_logo.jfif" alt="Client" />
                            <img src="img/ZAFFICO.jpg" alt="Client" />
                            <img src="img/mantle_lab.jfif" alt="Client" />
                            <img src="img/shar.png" alt="Client" />
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}

export default Amenities;